import { api } from "../config";


export const apiCallRadioCoverages = {
    Actions: {
        
        GetRadioCoverages: async (page = 1, pageSize = 10) => {
            try {
                const response = await api.get("RadioCoverage", {
                    params: {
                        nsApplication: process.env.REACT_APP_NS_APPLICATION,
                        page: page,
                        pageSize: pageSize,
                    },
                });
                return response.data;
            } catch (error) {
                console.error(error);
            }
        },

        sendRadioCoverage: async (radioCoverage) => {
            try {
                const response = await api.post("RadioCoverage", {
                    id: radioCoverage.id,
                    name: radioCoverage.name,
                    gatewayName: radioCoverage.gatewayName,
                    lat: radioCoverage.lat,
                    lng: radioCoverage.lng,
                    
                    deviceName: radioCoverage.deviceName,
                    createdAt: radioCoverage.createdAt,
                    nsApplication: process.env.REACT_APP_NS_APPLICATION

                });
                return response.data;
            } catch (error) {
                console.error(error);
            }
        },


        GetRadioCoverage: async (radioCoverage) => {
            try {
                const response = await api.get(`RadioCoverage/${radioCoverage.id}`, { data: "" });
                return response.data;
    
            } catch (error) {
                console.error(error);
            }
        },

        GetRadioCoveragePosition: async (page = 0, pageSize = 10, radioCoverage) => {
            try {
                const response = await api.get(`RadioCoveragePosition/all/${radioCoverage.id}`);
                return response.data;
            } catch (error) {
                console.error("API Error:", error);
            }
        },
        
        
        AddRadioCoveragePosition: async (radioCoverageId, positionLat, positionLng, positionTransmission) => {
            try {
                const response = await api.post('RadioCoveragePosition', {
                    id: null,
                    radioCoverageId: radioCoverageId,
                    lat: positionLat,
                    lng: positionLng,
                    transmission: positionTransmission,
                    createdAt: null,
                });
                
                return response.data;
            } catch (error) {
                console.error(error);
            }
        }
    }
}